import { IAuthenticationProvider, AuthEnvironment } from "../../interfaces/IAuthenticationProvider";
import { AuthSharedComponent } from "./AuthSharedComponent";

declare const OfficeFirstPartyAuth: any;

/*
    PPE stands for "Pre-production environment". Typically, resources in this
    environment would have the string "ppe" appended somewhere on their URL. 
     
    For ex: www.officeppe.com, www.spoppe.com, etc
*/
export class PpeAuthenticationProvider implements IAuthenticationProvider {
    private authSharedComponent: AuthSharedComponent = new AuthSharedComponent();

    Authenticate(): void {
        OfficeFirstPartyAuth.debugging = true;
        OfficeFirstPartyAuth.authorityOverride = "https://login.windows-ppe.net/";
        this.authSharedComponent.Authenticate();
    }

    async GetAccessToken(resource: string): Promise<string> {
        return await this.authSharedComponent.GetAccessToken(resource);
      }

    GetAuthEnvironment(): AuthEnvironment {
        return AuthEnvironment.PPE;
    }
}